// Centralized Chart.js palette + styling for Argus. Chart.js can't read our
// SCSS custom properties, so the concrete values from `variables.scss` are
// mirrored here as the single source of truth for chart colours. Argus is a
// fixed light theme, so — unlike Cvetko's dual-theme composable — these are
// plain constants, not reactive.

export const chartTheme = {
  // Text + axes (mirror $color-text / $color-text-muted / $color-border).
  text: '#0f172a',
  textMuted: '#64748b',
  grid: 'rgba(15, 23, 42, 0.08)',

  // Tooltip surface (mirror $color-surface-elevated / border / text).
  tooltipBg: '#ffffff',
  tooltipText: '#0f172a',
  tooltipBorder: '#cbd5e1',

  // Satisfied vs. not-satisfied — the two-colour scale the whole Certificate
  // Analysis page speaks in. Vivid enough to read as chart slices/bars while
  // staying in the green=good / red=gap convention used by the KPIs and legend.
  satisfied: '#16a34a',
  unmet: '#dc2626',

  // Categorical palette (borrowed from Cvetko) for any future multi-series
  // chart. Index with paletteColor() so it wraps safely.
  palette: [
    '#3b82f6', // blue
    '#10b981', // emerald
    '#f59e0b', // amber
    '#8b5cf6', // violet
    '#ec4899', // pink
    '#14b8a6', // teal
    '#f97316', // orange
    '#a855f7', // purple
    '#0ea5e9', // sky
    '#84cc16', // lime
  ],
} as const

export function paletteColor(i: number): string {
  const { palette } = chartTheme
  const safe = ((i % palette.length) + palette.length) % palette.length
  return palette[safe] ?? '#9ca3af'
}

// Shared tooltip styling so every chart's tooltip looks identical.
export const tooltipStyle = {
  backgroundColor: chartTheme.tooltipBg,
  titleColor: chartTheme.tooltipText,
  bodyColor: chartTheme.tooltipText,
  borderColor: chartTheme.tooltipBorder,
  borderWidth: 1,
  padding: 10,
  cornerRadius: 6,
  displayColors: true,
} as const
